import React, { useLayoutEffect, useState } from 'react';
import { flatten, max } from 'lodash';

import { SimpleBarChart } from '@magoosh/lib/charts';

interface SectionedBarGroupsProps {
  colorPalette: {
    dark: string;
    light: string;
  };
  data: {
    name?: string;
    data: {
      label: string;
      maximum?: number;
      percentage?: boolean;
      value: number;
    }[];
  }[];
}

export default (props: SectionedBarGroupsProps) => {
  const [labelWidth, setLabelWidth] = useState(0);

  useLayoutEffect(() => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = "14px 'Tondo', Arial, 'Helvetica Neue', Helvetica, sans-serif";

    const labels = flatten(props.data.map((group) => group.data.map((d) => d.label)));
    const width = max(labels.map((label) => context.measureText(label).width));

    setLabelWidth(width);
  }, [props.data]);

  return (
    <div className="d-flex flex-column gap-s">
      {
        props.data.map((group, idx) => (
          <div key={idx} className="d-flex flex-column gap-xs">
            {(() => {
              if (props.data.length > 1 && group.name) {
                return <div><small><strong>{group.name}</strong></small></div>;
              } else if (idx !== 0) {
                return <hr className="u-margin-A-xs" />;
              }
            })()}

            <SimpleBarChart
              colorPalette={props.colorPalette}
              data={group.data}
              labelWidth={labelWidth}
            />
          </div>
        ))
      }
    </div>
  );
};
